// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3vF8P","row":"ProcedureTreatmentSummary_row__3p5P_"};